<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center w-75">REVENUE HISTORY</h1>
            </article>

            <article class="input-section form-section">
              <div class="table-scroll">
                <table width="100%">
                  <thead>
                  <tr>
                    <th>Year</th>
                    <th>Total Gross Revenues ($)</th>
                    <th>Total Payroll ($)</th>
                    <th>Number of Employees</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      Projected
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="projectedRevenue"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="projectedRevenue"
                      >
                      <span
                        v-show="errors.has('projectedRevenue')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('projectedRevenue') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="projectedPayroll"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="projectedPayroll"
                      >
                      <span
                        v-show="errors.has('projectedPayroll')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('projectedPayroll') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="projectedNumberOfEmployees"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="projectedNumberOfEmployees"
                      >
                      <span
                        v-show="errors.has('projectedNumberOfEmployees')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('projectedNumberOfEmployees') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Expiring
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="expiringRevenue"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="expiringRevenue"
                      >
                      <span
                        v-show="errors.has('expiringRevenue')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('expiringRevenue') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="expiringPayroll"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="expiringPayroll"
                      >
                      <span
                        v-show="errors.has('expiringPayroll')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('expiringPayroll') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="expiringNumberOfEmployees"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="expiringNumberOfEmployees"
                      >
                      <span
                        v-show="errors.has('expiringNumberOfEmployees')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('expiringNumberOfEmployees') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      First Prior
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="firstPriorRevenue"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="firstPriorRevenue"
                      >
                      <span
                        v-show="errors.has('firstPriorRevenue')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('firstPriorRevenue') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="firstPriorPayroll"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="firstPriorPayroll"
                      >
                      <span
                        v-show="errors.has('firstPriorPayroll')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('firstPriorPayroll') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="firstPriorNumberOfEmployees"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="firstPriorNumberOfEmployees"
                      >
                      <span
                        v-show="errors.has('firstPriorNumberOfEmployees')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('firstPriorNumberOfEmployees') | filterText }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              
            </article>
            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center w-75">OPERATIONS AND SERVICES</h1>
            </article>

            <article class="input-section form-section table-scroll">
              <div class="table-scroll">
                <table width="100%">
                  <thead>
                  <tr>
                    <th>
                      ENVIRONMENTAL CONTRACTING OPERATIONS
                      <div class="radio orep-radio-wrapper solo-checkbox">
                        <label class="d-flex align-items-center">
                          <input
                            type="checkbox"
                            name="environmentalContracting"
                            value
                            class="orep-radio position-relative"
                            v-model="rcApplication.environmentalContracting"
                          >
                          <span class="radio-span solo-checkbox-span no-top">Check here if this section does not apply</span>
                        </label>
                      </div>

                    </th>
                    <th>
                      Projected Gross Revenues
                    </th>
                    <th>
                      % Revenues Subcontracted
                    </th>
                    <th>
                      Projected Payroll of Applicant
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      Asbestos Abatement
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueAsbestosAbatement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueAsbestosAbatement"
                      >
                      <span
                        v-show="errors.has('revenueAsbestosAbatement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueAsbestosAbatement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueAsbestosAbatement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueAsbestosAbatement"
                      >
                      <span
                        v-show="errors.has('percentageRevenueAsbestosAbatement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueAsbestosAbatement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollAsbestosAbatement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollAsbestosAbatement"
                      >
                      <span
                        v-show="errors.has('payrollAsbestosAbatement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollAsbestosAbatement') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Carpet Cleaning
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueCarpetCleaning"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueCarpetCleaning"
                      >
                      <span
                        v-show="errors.has('revenueCarpetCleaning')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueCarpetCleaning') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueCarpetCleaning"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueCarpetCleaning"
                      >
                      <span
                        v-show="errors.has('percentageRevenueCarpetCleaning')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueCarpetCleaning') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollCarpetCleaning"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollCarpetCleaning"
                      >
                      <span
                        v-show="errors.has('payrollCarpetCleaning')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollCarpetCleaning') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Debris Removal
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueDebrisRemoval"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueDebrisRemoval"
                      >
                      <span
                        v-show="errors.has('revenueDebrisRemoval')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueDebrisRemoval') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueDebrisRemoval"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueDebrisRemoval"
                      >
                      <span
                        v-show="errors.has('percentageRevenueDebrisRemoval')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueDebrisRemoval') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollDebrisRemoval"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollDebrisRemoval"
                      >
                      <span
                        v-show="errors.has('payrollDebrisRemoval')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollDebrisRemoval') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Duct Cleaning
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueDuctCleaning"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueDuctCleaning"
                      >
                      <span
                        v-show="errors.has('revenueDuctCleaning')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueDuctCleaning') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueDuctCleaning"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueDuctCleaning"
                      >
                      <span
                        v-show="errors.has('percentageRevenueDuctCleaning')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueDuctCleaning') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollDuctCleaning"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollDuctCleaning"
                      >
                      <span
                        v-show="errors.has('payrollDuctCleaning')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollDuctCleaning') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Lead Abatement
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueLeadAbatement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueLeadAbatement"
                      >
                      <span
                        v-show="errors.has('revenueLeadAbatement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueLeadAbatement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueLeadAbatement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueLeadAbatement"
                      >
                      <span
                        v-show="errors.has('percentageRevenueLeadAbatement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueLeadAbatement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollLeadAbatement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollLeadAbatement"
                      >
                      <span
                        v-show="errors.has('payrollLeadAbatement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollLeadAbatement') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Mold/Fungus Abatement – Commercial
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueFungusAbatementCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueFungusAbatementCommercial"
                      >
                      <span
                        v-show="errors.has('revenueFungusAbatementCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueFungusAbatementCommercial') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueFungusAbatementCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueFungusAbatementCommercial"
                      >
                      <span
                        v-show="errors.has('percentageRevenueFungusAbatementCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueFungusAbatementCommercial') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollFungusAbatementCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollFungusAbatementCommercial"
                      >
                      <span
                        v-show="errors.has('payrollFungusAbatementCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollFungusAbatementCommercial') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Mold/Fungus Abatement – Residential
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueFungusAbatementResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueFungusAbatementResidential"
                      >
                      <span
                        v-show="errors.has('revenueFungusAbatementResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueFungusAbatementResidential') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueFungusAbatementResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueFungusAbatementResidential"
                      >
                      <span
                        v-show="errors.has('percentageRevenueFungusAbatementResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueFungusAbatementResidential') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollFungusAbatementResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollFungusAbatementResidential"
                      >
                      <span
                        v-show="errors.has('payrollFungusAbatementResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollFungusAbatementResidential') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Pack-outs / Contents
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenuePackOuts"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenuePackOuts"
                      >
                      <span
                        v-show="errors.has('revenuePackOuts')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenuePackOuts') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenuePackOuts"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenuePackOuts"
                      >
                      <span
                        v-show="errors.has('percentageRevenuePackOuts')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenuePackOuts') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollPackOuts"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollPackOuts"
                      >
                      <span
                        v-show="errors.has('payrollPackOuts')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollPackOuts') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Smoke / Odor removal
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueSmoke"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueSmoke"
                      >
                      <span
                        v-show="errors.has('revenueSmoke')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueSmoke') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueSmoke"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueSmoke"
                      >
                      <span
                        v-show="errors.has('percentageRevenueSmoke')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueSmoke') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollSmoke"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollSmoke"
                      >
                      <span
                        v-show="errors.has('payrollSmoke')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollSmoke') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Sewage Cleanup
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueSewageCleanup"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueSewageCleanup"
                      >
                      <span
                        v-show="errors.has('revenueSewageCleanup')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueSewageCleanup') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueSewageCleanup"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueSewageCleanup"
                      >
                      <span
                        v-show="errors.has('percentageRevenueSewageCleanup')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueSewageCleanup') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollSewageCleanup"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollSewageCleanup"
                      >
                      <span
                        v-show="errors.has('payrollSewageCleanup')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollSewageCleanup') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Trauma / Crime Scene Cleanup
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueTrauma"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueTrauma"
                      >
                      <span
                        v-show="errors.has('revenueTrauma')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueTrauma') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueTrauma"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueTrauma"
                      >
                      <span
                        v-show="errors.has('percentageRevenueTrauma')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueTrauma') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollTrauma"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollTrauma"
                      >
                      <span
                        v-show="errors.has('payrollTrauma')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollTrauma') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Water Extraction
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueWaterExtraction"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueWaterExtraction"
                      >
                      <span
                        v-show="errors.has('revenueWaterExtraction')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueWaterExtraction') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueWaterExtraction"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueWaterExtraction"
                      >
                      <span
                        v-show="errors.has('percentageRevenueWaterExtraction')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueWaterExtraction') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollWaterExtraction"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollWaterExtraction"
                      >
                      <span
                        v-show="errors.has('payrollWaterExtraction')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollWaterExtraction') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Other (explain):
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueEnvironmentalOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueEnvironmentalOther"
                      >
                      <span
                        v-show="errors.has('revenueEnvironmentalOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueEnvironmentalOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueEnvironmentalOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueEnvironmentalOther"
                      >
                      <span
                        v-show="errors.has('percentageRevenueEnvironmentalOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueEnvironmentalOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollEnvironmentalOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollEnvironmentalOther"
                      >
                      <span
                        v-show="errors.has('payrollEnvironmentalOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollEnvironmentalOther') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      CONSTRUCTION AND BUILD-BACK CONTRACTING OPERATIONS
                      <div class="radio orep-radio-wrapper solo-checkbox">
                        <label class="d-flex align-items-center">
                          <input
                            type="checkbox"
                            name="constructionAndBuildBack"
                            value
                            class="orep-radio position-relative"
                            v-model="rcApplication.constructionAndBuildBack"
                          >
                          <span class="radio-span solo-checkbox-span no-top">Check here if this section does not apply</span>
                        </label>
                      </div>
                    </th>
                    <th>
                      Projected Gross Revenues
                    </th>
                    <th>
                      % Revenues Subcontracted
                    </th>
                    <th>
                      Projected Payroll of Applicant
                    </th>
                  </tr>
                  <tr>
                    <td>
                      Carpentry / Drywall / Wallboard Installation
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueCarpentry"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueCarpentry"
                      >
                      <span
                        v-show="errors.has('revenueCarpentry')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueCarpentry') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueCarpentry"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueCarpentry"
                      >
                      <span
                        v-show="errors.has('percentageRevenueCarpentry')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueCarpentry') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollCarpentry"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollCarpentry"
                      >
                      <span
                        v-show="errors.has('payrollCarpentry')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollCarpentry') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Concrete
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueConcrete"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueConcrete"
                      >
                      <span
                        v-show="errors.has('revenueConcrete')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueConcrete') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueConcrete"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueConcrete"
                      >
                      <span
                        v-show="errors.has('percentageRevenueConcrete')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueConcrete') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollConcrete"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollConcrete"
                      >
                      <span
                        v-show="errors.has('payrollConcrete')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollConcrete') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Demolition - Exterior
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueDemolitionExterior"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueDemolitionExterior"
                      >
                      <span
                        v-show="errors.has('revenueDemolitionExterior')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueDemolitionExterior') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueDemolitionExterior"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueDemolitionExterior"
                      >
                      <span
                        v-show="errors.has('percentageRevenueDemolitionExterior')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueDemolitionExterior') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollDemolitionExterior"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollDemolitionExterior"
                      >
                      <span
                        v-show="errors.has('payrollDemolitionExterior')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollDemolitionExterior') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Demolition - Interior
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueDemolitionInterior"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueDemolitionInterior"
                      >
                      <span
                        v-show="errors.has('revenueDemolitionInterior')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueDemolitionInterior') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueDemolitionInterior"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueDemolitionInterior"
                      >
                      <span
                        v-show="errors.has('percentageRevenueDemolitionInterior')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueDemolitionInterior') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollDemolitionInterior"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollDemolitionInterior"
                      >
                      <span
                        v-show="errors.has('payrollDemolitionInterior')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollDemolitionInterior') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Electrical
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueElectrical"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueElectrical"
                      >
                      <span
                        v-show="errors.has('revenueElectrical')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueElectrical') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueElectrical"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueElectrical"
                      >
                      <span
                        v-show="errors.has('percentageRevenueElectrical')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueElectrical') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollElectrical"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollElectrical"
                      >
                      <span
                        v-show="errors.has('payrollElectrical')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollElectrical') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Excavation/Grading
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueExcavation"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueExcavation"
                      >
                      <span
                        v-show="errors.has('revenueExcavation')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueExcavation') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueExcavation"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueExcavation"
                      >
                      <span
                        v-show="errors.has('percentageRevenueExcavation')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueExcavation') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollExcavation"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollExcavation"
                      >
                      <span
                        v-show="errors.has('payrollExcavation')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollExcavation') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Flooring
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueFlooring"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueFlooring"
                      >
                      <span
                        v-show="errors.has('revenueFlooring')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueFlooring') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueFlooring"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueFlooring"
                      >
                      <span
                        v-show="errors.has('percentageRevenueFlooring')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueFlooring') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollFlooring"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollFlooring"
                      >
                      <span
                        v-show="errors.has('payrollFlooring')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollFlooring') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      HVAC
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueHvac"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueHvac"
                      >
                      <span
                        v-show="errors.has('revenueHvac')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueHvac') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueHvac"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueHvac"
                      >
                      <span
                        v-show="errors.has('percentageRevenueHvac')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueHvac') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollHvac"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollHvac"
                      >
                      <span
                        v-show="errors.has('payrollHvac')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollHvac') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Insulation
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueInsulation"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueInsulation"
                      >
                      <span
                        v-show="errors.has('revenueInsulation')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueInsulation') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueInsulation"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueInsulation"
                      >
                      <span
                        v-show="errors.has('percentageRevenueInsulation')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueInsulation') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollInsulation"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollInsulation"
                      >
                      <span
                        v-show="errors.has('payrollInsulation')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollInsulation') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Maintenance/Janitorial/Commercial Cleaning
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueMaintenance"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueMaintenance"
                      >
                      <span
                        v-show="errors.has('revenueMaintenance')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueMaintenance') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueMaintenance"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueMaintenance"
                      >
                      <span
                        v-show="errors.has('percentageRevenueMaintenance')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueMaintenance') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollMaintenance"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollMaintenance"
                      >
                      <span
                        v-show="errors.has('payrollMaintenance')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollMaintenance') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Metal Erection
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueMetalErection"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueMetalErection"
                      >
                      <span
                        v-show="errors.has('revenueMetalErection')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueMetalErection') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueMetalErection"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueMetalErection"
                      >
                      <span
                        v-show="errors.has('percentageRevenueMetalErection')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueMetalErection') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollMetalErection"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollMetalErection"
                      >
                      <span
                        v-show="errors.has('payrollMetalErection')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollMetalErection') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Painting
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenuePainting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenuePainting"
                      >
                      <span
                        v-show="errors.has('revenuePainting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenuePainting') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenuePainting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenuePainting"
                      >
                      <span
                        v-show="errors.has('percentageRevenuePainting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenuePainting') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollPainting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollPainting"
                      >
                      <span
                        v-show="errors.has('payrollPainting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollPainting') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Plumbing - Commercial
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenuePlumbingCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenuePlumbingCommercial"
                      >
                      <span
                        v-show="errors.has('revenuePlumbingCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenuePlumbingCommercial') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenuePlumbingCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenuePlumbingCommercial"
                      >
                      <span
                        v-show="errors.has('percentageRevenuePlumbingCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenuePlumbingCommercial') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollPlumbingCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollPlumbingCommercial"
                      >
                      <span
                        v-show="errors.has('payrollPlumbingCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollPlumbingCommercial') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Plumbing - Residential
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenuePlumbingResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenuePlumbingResidential"
                      >
                      <span
                        v-show="errors.has('revenuePlumbingResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenuePlumbingResidential') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenuePlumbingResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenuePlumbingResidential"
                      >
                      <span
                        v-show="errors.has('percentageRevenuePlumbingResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenuePlumbingResidential') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollPlumbingResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollPlumbingResidential"
                      >
                      <span
                        v-show="errors.has('payrollPlumbingResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollPlumbingResidential') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Roofing – Commercial/Residential
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueRoofing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueRoofing"
                      >
                      <span
                        v-show="errors.has('revenueRoofing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueRoofing') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueRoofing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueRoofing"
                      >
                      <span
                        v-show="errors.has('percentageRevenueRoofing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueRoofing') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollRoofing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollRoofing"
                      >
                      <span
                        v-show="errors.has('payrollRoofing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollRoofing') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Siding/Window Installation
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueSiding"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueSiding"
                      >
                      <span
                        v-show="errors.has('revenueSiding')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueSiding') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueSiding"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueSiding"
                      >
                      <span
                        v-show="errors.has('percentageRevenueSiding')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueSiding') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollSiding"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollSiding"
                      >
                      <span
                        v-show="errors.has('payrollSiding')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollSiding') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Other (explain):
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueConstructionOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueConstructionOther"
                      >
                      <span
                        v-show="errors.has('revenueConstructionOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueConstructionOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueConstructionOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueConstructionOther"
                      >
                      <span
                        v-show="errors.has('percentageRevenueConstructionOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueConstructionOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollConstructionOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollConstructionOther"
                      >
                      <span
                        v-show="errors.has('payrollConstructionOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollConstructionOther') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      PROFESSIONAL SERVICES
                      <div class="radio orep-radio-wrapper solo-checkbox">
                        <label class="d-flex align-items-center">
                          <input
                            type="checkbox"
                            name="professionalServices"
                            value
                            class="orep-radio position-relative"
                            v-model="rcApplication.professionalServices"
                          >
                          <span class="radio-span solo-checkbox-span no-top">Check here if this section does not apply</span>
                        </label>
                      </div>

                    </th>
                    <th>
                      Projected Gross Revenues
                    </th>
                    <th>
                      % Revenues Subcontracted
                    </th>
                    <th>
                      Projected Payroll of Applicant
                    </th>
                  </tr>
                  <tr>
                    <td>
                      Analytical Laboratories
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueAnalyticalLaboratories"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueAnalyticalLaboratories"
                      >
                      <span
                        v-show="errors.has('revenueAnalyticalLaboratories')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueAnalyticalLaboratories') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueAnalyticalLaboratories"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueAnalyticalLaboratories"
                      >
                      <span
                        v-show="errors.has('percentageRevenueAnalyticalLaboratories')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueAnalyticalLaboratories') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollAnalyticalLaboratories"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollAnalyticalLaboratories"
                      >
                      <span
                        v-show="errors.has('payrollAnalyticalLaboratories')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollAnalyticalLaboratories') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Asbestos and/or Lead Consulting
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueAsbestos"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueAsbestos"
                      >
                      <span
                        v-show="errors.has('revenueAsbestos')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueAsbestos') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueAsbestos"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueAsbestos"
                      >
                      <span
                        v-show="errors.has('percentageRevenueAsbestos')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueAsbestos') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollAsbestos"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollAsbestos"
                      >
                      <span
                        v-show="errors.has('payrollAsbestos')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollAsbestos') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Construction Management
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueConstructionManagement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueConstructionManagement"
                      >
                      <span
                        v-show="errors.has('revenueConstructionManagement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueConstructionManagement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueConstructionManagement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueConstructionManagement"
                      >
                      <span
                        v-show="errors.has('percentageRevenueConstructionManagement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueConstructionManagement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollConstructionManagement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollConstructionManagement"
                      >
                      <span
                        v-show="errors.has('payrollConstructionManagement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollConstructionManagement') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Environmental Consulting
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueEnvironmentalConsulting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueEnvironmentalConsulting"
                      >
                      <span
                        v-show="errors.has('revenueEnvironmentalConsulting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueEnvironmentalConsulting') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueEnvironmentalConsulting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueEnvironmentalConsulting"
                      >
                      <span
                        v-show="errors.has('percentageRevenueEnvironmentalConsulting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueEnvironmentalConsulting') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollEnvironmentalConsulting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollEnvironmentalConsulting"
                      >
                      <span
                        v-show="errors.has('payrollEnvironmentalConsulting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollEnvironmentalConsulting') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Mold/Fungus Assessments/Testing/Consulting – Commercial
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueMoldFungusCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueMoldFungusCommercial"
                      >
                      <span
                        v-show="errors.has('revenueMoldFungusCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueMoldFungusCommercial') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueMoldFungusCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueMoldFungusCommercial"
                      >
                      <span
                        v-show="errors.has('percentageRevenueMoldFungusCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueMoldFungusCommercial') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollMoldFungusCommercial"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollMoldFungusCommercial"
                      >
                      <span
                        v-show="errors.has('payrollMoldFungusCommercial')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollMoldFungusCommercial') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Mold/Fungus Assessments/Testing/Consulting – Residential
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueMoldFungusResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueMoldFungusResidential"
                      >
                      <span
                        v-show="errors.has('revenueMoldFungusResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueMoldFungusResidential') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueMoldFungusResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueMoldFungusResidential"
                      >
                      <span
                        v-show="errors.has('percentageRevenueMoldFungusResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueMoldFungusResidential') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollMoldFungusResidential"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollMoldFungusResidential"
                      >
                      <span
                        v-show="errors.has('payrollMoldFungusResidential')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollMoldFungusResidential') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Other (explain):
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="revenueProfessionalOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="revenueProfessionalOther"
                      >
                      <span
                        v-show="errors.has('revenueProfessionalOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('revenueProfessionalOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="percentageRevenueProfessionalOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="percentageRevenueProfessionalOther"
                      >
                      <span
                        v-show="errors.has('percentageRevenueProfessionalOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('percentageRevenueProfessionalOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="payrollProfessionalOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="payrollProfessionalOther"
                      >
                      <span
                        v-show="errors.has('payrollProfessionalOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('payrollProfessionalOther') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      TOTAL FOR ALL PROFESSIONAL SERVICES
                    </th>
                    <th>
                      $
                    </th>
                    <th>
                      %
                    </th>
                    <th>
                      $
                    </th>
                  </tr>

                  </tbody>
                </table>
              </div>
              
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'rc-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button @click="prev()" class="pagination-dots"></button>
            <button class="pagination-dots pagination-current"></button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid"
              @click="navigateToNext('rc-application-3')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
              @click="navigateToNext('rc-application-4')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid"
              @click="navigateToNext('pageTwoIsValid-appraiser-5')">
            </button>
            <button
              class="pagination-dots"
              @click="navigateToNext('rc-application-6')"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageTwoIsValid"
            :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('rc-application-3')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "rc-application-2",
  beforeMount(){
    this.validateBeforeSubmit()
  },
  computed: {
    rcApplication() {
      return this.$store.state.rcApplication.rcApplication;
    },
    state() {
      return this.$store.state.rcApplication;
    },
    errorMsg() {
      return this.$store.state.rcApplication.errorMsg;
    },
    projectedRevenue: {
      get: function() {
        return this.rcApplication.projectedRevenue || '';
      },
      set: function(val) {
        this.rcApplication.projectedRevenue = val;
      }
    },
    projectedPayroll: {
      get: function() {
        return this.rcApplication.projectedPayroll || '';
      },
      set: function(val) {
        this.rcApplication.projectedPayroll = val;
      }
    },
    projectedNumberOfEmployees: {
      get: function() {
        return this.rcApplication.projectedNumberOfEmployees || '';
      },
      set: function(val) {
        this.rcApplication.projectedNumberOfEmployees = val;
      }
    },

    expiringRevenue: {
      get: function() {
        return this.rcApplication.expiringRevenue || '';
      },
      set: function(val) {
        this.rcApplication.expiringRevenue = val;
      }
    },
    expiringPayroll: {
      get: function() {
        return this.rcApplication.expiringPayroll || '';
      },
      set: function(val) {
        this.rcApplication.expiringPayroll = val;
      }
    },
    expiringNumberOfEmployees: {
      get: function() {
        return this.rcApplication.expiringNumberOfEmployees || '';
      },
      set: function(val) {
        this.rcApplication.expiringNumberOfEmployees = val;
      }
    },

    firstPriorRevenue: {
      get: function() {
        return this.rcApplication.firstPriorRevenue || '';
      },
      set: function(val) {
        this.rcApplication.firstPriorRevenue = val;
      }
    },
    firstPriorPayroll: {
      get: function() {
        return this.rcApplication.firstPriorPayroll || '';
      },
      set: function(val) {
        this.rcApplication.firstPriorPayroll = val;
      }
    },
    firstPriorNumberOfEmployees: {
      get: function() {
        return this.rcApplication.firstPriorNumberOfEmployees || '';
      },
      set: function(val) {
        this.rcApplication.firstPriorNumberOfEmployees = val;
      }
    },
    revenueAsbestosAbatement: {
      get: function() {
        return this.rcApplication.revenueAsbestosAbatement || '';
      },
      set: function(val) {
        this.rcApplication.revenueAsbestosAbatement = val;
      }
    },
    percentageRevenueAsbestosAbatement: {
      get: function() {
        return this.rcApplication.percentageRevenueAsbestosAbatement || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueAsbestosAbatement = val;
      }
    },
    payrollAsbestosAbatement: {
      get: function() {
        return this.rcApplication.payrollAsbestosAbatement || '';
      },
      set: function(val) {
        this.rcApplication.payrollAsbestosAbatement = val;
      }
    },
    revenueCarpetCleaning: {
      get: function() {
        return this.rcApplication.revenueCarpetCleaning || '';
      },
      set: function(val) {
        this.rcApplication.revenueCarpetCleaning = val;
      }
    },
    percentageRevenueCarpetCleaning: {
      get: function() {
        return this.rcApplication.percentageRevenueCarpetCleaning || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueCarpetCleaning = val;
      }
    },
    payrollCarpetCleaning: {
      get: function() {
        return this.rcApplication.payrollCarpetCleaning || '';
      },
      set: function(val) {
        this.rcApplication.payrollCarpetCleaning = val;
      }
    },
    revenueDebrisRemoval: {
      get: function() {
        return this.rcApplication.revenueDebrisRemoval || '';
      },
      set: function(val) {
        this.rcApplication.revenueDebrisRemoval = val;
      }
    },
    percentageRevenueDebrisRemoval: {
      get: function() {
        return this.rcApplication.percentageRevenueDebrisRemoval || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueDebrisRemoval = val;
      }
    },
    payrollDebrisRemoval: {
      get: function() {
        return this.rcApplication.payrollDebrisRemoval || '';
      },
      set: function(val) {
        this.rcApplication.payrollDebrisRemoval = val;
      }
    },
    revenueDuctCleaning: {
      get: function() {
        return this.rcApplication.revenueDuctCleaning || '';
      },
      set: function(val) {
        this.rcApplication.revenueDuctCleaning = val;
      }
    },
    percentageRevenueDuctCleaning: {
      get: function() {
        return this.rcApplication.percentageRevenueDuctCleaning || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueDuctCleaning = val;
      }
    },
    payrollDuctCleaning: {
      get: function() {
        return this.rcApplication.payrollDuctCleaning || '';
      },
      set: function(val) {
        this.rcApplication.payrollDuctCleaning = val;
      }
    },
    revenueLeadAbatement: {
      get: function() {
        return this.rcApplication.revenueLeadAbatement || '';
      },
      set: function(val) {
        this.rcApplication.revenueLeadAbatement = val;
      }
    },
    percentageRevenueLeadAbatement: {
      get: function() {
        return this.rcApplication.percentageRevenueLeadAbatement || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueLeadAbatement = val;
      }
    },
    payrollLeadAbatement: {
      get: function() {
        return this.rcApplication.payrollLeadAbatement || '';
      },
      set: function(val) {
        this.rcApplication.payrollLeadAbatement = val;
      }
    },
    revenueFungusAbatementCommercial: {
      get: function() {
        return this.rcApplication.revenueFungusAbatementCommercial || '';
      },
      set: function(val) {
        this.rcApplication.revenueFungusAbatementCommercial = val;
      }
    },
    percentageRevenueFungusAbatementCommercial: {
      get: function() {
        return this.rcApplication.percentageRevenueFungusAbatementCommercial || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueFungusAbatementCommercial = val;
      }
    },
    payrollFungusAbatementCommercial: {
      get: function() {
        return this.rcApplication.payrollFungusAbatementCommercial || '';
      },
      set: function(val) {
        this.rcApplication.payrollFungusAbatementCommercial = val;
      }
    },
    revenueFungusAbatementResidential: {
      get: function() {
        return this.rcApplication.revenueFungusAbatementResidential || '';
      },
      set: function(val) {
        this.rcApplication.revenueFungusAbatementResidential = val;
      }
    },
    percentageRevenueFungusAbatementResidential: {
      get: function() {
        return this.rcApplication.percentageRevenueFungusAbatementResidential || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueFungusAbatementResidential = val;
      }
    },
    payrollFungusAbatementResidential: {
      get: function() {
        return this.rcApplication.payrollFungusAbatementResidential || '';
      },
      set: function(val) {
        this.rcApplication.payrollFungusAbatementResidential = val;
      }
    },
    revenuePackOuts: {
      get: function() {
        return this.rcApplication.revenuePackOuts || '';
      },
      set: function(val) {
        this.rcApplication.revenuePackOuts = val;
      }
    },
    percentageRevenuePackOuts: {
      get: function() {
        return this.rcApplication.percentageRevenuePackOuts || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenuePackOuts = val;
      }
    },
    payrollPackOuts: {
      get: function() {
        return this.rcApplication.payrollPackOuts || '';
      },
      set: function(val) {
        this.rcApplication.payrollPackOuts = val;
      }
    },
    revenueSmoke: {
      get: function() {
        return this.rcApplication.revenueSmoke || '';
      },
      set: function(val) {
        this.rcApplication.revenueSmoke = val;
      }
    },
    percentageRevenueSmoke: {
      get: function() {
        return this.rcApplication.percentageRevenueSmoke || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueSmoke = val;
      }
    },
    payrollSmoke: {
      get: function() {
        return this.rcApplication.payrollSmoke || '';
      },
      set: function(val) {
        this.rcApplication.payrollSmoke = val;
      }
    },
    revenueSewageCleanup: {
      get: function() {
        return this.rcApplication.revenueSewageCleanup || '';
      },
      set: function(val) {
        this.rcApplication.revenueSewageCleanup = val;
      }
    },
    percentageRevenueSewageCleanup: {
      get: function() {
        return this.rcApplication.percentageRevenueSewageCleanup || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueSewageCleanup = val;
      }
    },
    payrollSewageCleanup: {
      get: function() {
        return this.rcApplication.payrollSewageCleanup || '';
      },
      set: function(val) {
        this.rcApplication.payrollSewageCleanup = val;
      }
    },
    revenueTrauma: {
      get: function() {
        return this.rcApplication.revenueTrauma || '';
      },
      set: function(val) {
        this.rcApplication.revenueTrauma = val;
      }
    },
    percentageRevenueTrauma: {
      get: function() {
        return this.rcApplication.percentageRevenueTrauma || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueTrauma = val;
      }
    },
    payrollTrauma: {
      get: function() {
        return this.rcApplication.payrollTrauma || '';
      },
      set: function(val) {
        this.rcApplication.payrollTrauma = val;
      }
    },
    revenueWaterExtraction: {
      get: function() {
        return this.rcApplication.revenueWaterExtraction || '';
      },
      set: function(val) {
        this.rcApplication.revenueWaterExtraction = val;
      }
    },
    percentageRevenueWaterExtraction: {
      get: function() {
        return this.rcApplication.percentageRevenueWaterExtraction || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueWaterExtraction = val;
      }
    },
    payrollWaterExtraction: {
      get: function() {
        return this.rcApplication.payrollWaterExtraction || '';
      },
      set: function(val) {
        this.rcApplication.payrollWaterExtraction = val;
      }
    },
    revenueEnvironmentalOther: {
      get: function() {
        return this.rcApplication.revenueEnvironmentalOther || '';
      },
      set: function(val) {
        this.rcApplication.revenueEnvironmentalOther = val;
      }
    },
    percentageRevenueEnvironmentalOther: {
      get: function() {
        return this.rcApplication.percentageRevenueEnvironmentalOther || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueEnvironmentalOther = val;
      }
    },
    payrollEnvironmentalOther: {
      get: function() {
        return this.rcApplication.payrollEnvironmentalOther || '';
      },
      set: function(val) {
        this.rcApplication.payrollEnvironmentalOther = val;
      }
    },
    revenueCarpentry: {
      get: function() {
        return this.rcApplication.revenueCarpentry || '';
      },
      set: function(val) {
        this.rcApplication.revenueCarpentry = val;
      }
    },
    percentageRevenueCarpentry: {
      get: function() {
        return this.rcApplication.percentageRevenueCarpentry || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueCarpentry = val;
      }
    },
    payrollCarpentry: {
      get: function() {
        return this.rcApplication.payrollCarpentry || '';
      },
      set: function(val) {
        this.rcApplication.payrollCarpentry = val;
      }
    },
    revenueConcrete: {
      get: function() {
        return this.rcApplication.revenueConcrete || '';
      },
      set: function(val) {
        this.rcApplication.revenueConcrete = val;
      }
    },
    percentageRevenueConcrete: {
      get: function() {
        return this.rcApplication.percentageRevenueConcrete || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueConcrete = val;
      }
    },
    payrollConcrete: {
      get: function() {
        return this.rcApplication.payrollConcrete || '';
      },
      set: function(val) {
        this.rcApplication.payrollConcrete = val;
      }
    },
    revenueDemolitionExterior: {
      get: function() {
        return this.rcApplication.revenueDemolitionExterior || '';
      },
      set: function(val) {
        this.rcApplication.revenueDemolitionExterior = val;
      }
    },
    percentageRevenueDemolitionExterior: {
      get: function() {
        return this.rcApplication.percentageRevenueDemolitionExterior || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueDemolitionExterior = val;
      }
    },
    payrollDemolitionExterior: {
      get: function() {
        return this.rcApplication.payrollDemolitionExterior || '';
      },
      set: function(val) {
        this.rcApplication.payrollDemolitionExterior = val;
      }
    },
    revenueDemolitionInterior: {
      get: function() {
        return this.rcApplication.revenueDemolitionInterior || '';
      },
      set: function(val) {
        this.rcApplication.revenueDemolitionInterior = val;
      }
    },
    percentageRevenueDemolitionInterior: {
      get: function() {
        return this.rcApplication.percentageRevenueDemolitionInterior || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueDemolitionInterior = val;
      }
    },
    payrollDemolitionInterior: {
      get: function() {
        return this.rcApplication.payrollDemolitionInterior || '';
      },
      set: function(val) {
        this.rcApplication.payrollDemolitionInterior = val;
      }
    },
    revenueElectrical: {
      get: function() {
        return this.rcApplication.revenueElectrical || '';
      },
      set: function(val) {
        this.rcApplication.revenueElectrical = val;
      }
    },
    percentageRevenueElectrical: {
      get: function() {
        return this.rcApplication.percentageRevenueElectrical || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueElectrical = val;
      }
    },
    payrollElectrical: {
      get: function() {
        return this.rcApplication.payrollElectrical || '';
      },
      set: function(val) {
        this.rcApplication.payrollElectrical = val;
      }
    },
    revenueExcavation: {
      get: function() {
        return this.rcApplication.revenueExcavation || '';
      },
      set: function(val) {
        this.rcApplication.revenueExcavation = val;
      }
    },
    percentageRevenueExcavation: {
      get: function() {
        return this.rcApplication.percentageRevenueExcavation || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueExcavation = val;
      }
    },
    payrollExcavation: {
      get: function() {
        return this.rcApplication.payrollExcavation || '';
      },
      set: function(val) {
        this.rcApplication.payrollExcavation = val;
      }
    },
    revenueFlooring: {
      get: function() {
        return this.rcApplication.revenueFlooring || '';
      },
      set: function(val) {
        this.rcApplication.revenueFlooring = val;
      }
    },
    percentageRevenueFlooring: {
      get: function() {
        return this.rcApplication.percentageRevenueFlooring || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueFlooring = val;
      }
    },
    payrollFlooring: {
      get: function() {
        return this.rcApplication.payrollFlooring || '';
      },
      set: function(val) {
        this.rcApplication.payrollFlooring = val;
      }
    },
    revenueHvac: {
      get: function() {
        return this.rcApplication.revenueHvac || '';
      },
      set: function(val) {
        this.rcApplication.revenueHvac = val;
      }
    },
    percentageRevenueHvac: {
      get: function() {
        return this.rcApplication.percentageRevenueHvac || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueHvac = val;
      }
    },
    payrollHvac: {
      get: function() {
        return this.rcApplication.payrollHvac || '';
      },
      set: function(val) {
        this.rcApplication.payrollHvac = val;
      }
    },
    revenueInsulation: {
      get: function() {
        return this.rcApplication.revenueInsulation || '';
      },
      set: function(val) {
        this.rcApplication.revenueInsulation = val;
      }
    },
    percentageRevenueInsulation: {
      get: function() {
        return this.rcApplication.percentageRevenueInsulation || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueInsulation = val;
      }
    },
    payrollInsulation: {
      get: function() {
        return this.rcApplication.payrollInsulation || '';
      },
      set: function(val) {
        this.rcApplication.payrollInsulation = val;
      }
    },
    revenueMaintenance: {
      get: function() {
        return this.rcApplication.revenueMaintenance || '';
      },
      set: function(val) {
        this.rcApplication.revenueMaintenance = val;
      }
    },
    percentageRevenueMaintenance: {
      get: function() {
        return this.rcApplication.percentageRevenueMaintenance || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueMaintenance = val;
      }
    },
    payrollMaintenance: {
      get: function() {
        return this.rcApplication.payrollMaintenance || '';
      },
      set: function(val) {
        this.rcApplication.payrollMaintenance = val;
      }
    },
    revenueMetalErection: {
      get: function() {
        return this.rcApplication.revenueMetalErection || '';
      },
      set: function(val) {
        this.rcApplication.revenueMetalErection = val;
      }
    },
    percentageRevenueMetalErection: {
      get: function() {
        return this.rcApplication.percentageRevenueMetalErection || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueMetalErection = val;
      }
    },
    payrollMetalErection: {
      get: function() {
        return this.rcApplication.payrollMetalErection || '';
      },
      set: function(val) {
        this.rcApplication.payrollMetalErection = val;
      }
    },
    revenuePainting: {
      get: function() {
        return this.rcApplication.revenuePainting || '';
      },
      set: function(val) {
        this.rcApplication.revenuePainting = val;
      }
    },
    percentageRevenuePainting: {
      get: function() {
        return this.rcApplication.percentageRevenuePainting || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenuePainting = val;
      }
    },
    payrollPainting: {
      get: function() {
        return this.rcApplication.payrollPainting || '';
      },
      set: function(val) {
        this.rcApplication.payrollPainting = val;
      }
    },
    revenuePlumbingCommercial: {
      get: function() {
        return this.rcApplication.revenuePlumbingCommercial || '';
      },
      set: function(val) {
        this.rcApplication.revenuePlumbingCommercial = val;
      }
    },
    percentageRevenuePlumbingCommercial: {
      get: function() {
        return this.rcApplication.percentageRevenuePlumbingCommercial || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenuePlumbingCommercial = val;
      }
    },
    payrollPlumbingCommercial: {
      get: function() {
        return this.rcApplication.payrollPlumbingCommercial || '';
      },
      set: function(val) {
        this.rcApplication.payrollPlumbingCommercial = val;
      }
    },
    revenuePlumbingResidential: {
      get: function() {
        return this.rcApplication.revenuePlumbingResidential || '';
      },
      set: function(val) {
        this.rcApplication.revenuePlumbingResidential = val;
      }
    },
    percentageRevenuePlumbingResidential: {
      get: function() {
        return this.rcApplication.percentageRevenuePlumbingResidential || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenuePlumbingResidential = val;
      }
    },
    payrollPlumbingResidential: {
      get: function() {
        return this.rcApplication.payrollPlumbingResidential || '';
      },
      set: function(val) {
        this.rcApplication.payrollPlumbingResidential = val;
      }
    },
    revenueRoofing: {
      get: function() {
        return this.rcApplication.revenueRoofing || '';
      },
      set: function(val) {
        this.rcApplication.revenueRoofing = val;
      }
    },
    percentageRevenueRoofing: {
      get: function() {
        return this.rcApplication.percentageRevenueRoofing || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueRoofing = val;
      }
    },
    payrollRoofing: {
      get: function() {
        return this.rcApplication.payrollRoofing || '';
      },
      set: function(val) {
        this.rcApplication.payrollRoofing = val;
      }
    },
    revenueSiding: {
      get: function() {
        return this.rcApplication.revenueSiding || '';
      },
      set: function(val) {
        this.rcApplication.revenueSiding = val;
      }
    },
    percentageRevenueSiding: {
      get: function() {
        return this.rcApplication.percentageRevenueSiding || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueSiding = val;
      }
    },
    payrollSiding: {
      get: function() {
        return this.rcApplication.payrollSiding || '';
      },
      set: function(val) {
        this.rcApplication.payrollSiding = val;
      }
    },
    revenueConstructionOther: {
      get: function() {
        return this.rcApplication.revenueConstructionOther || '';
      },
      set: function(val) {
        this.rcApplication.revenueConstructionOther = val;
      }
    },
    percentageRevenueConstructionOther: {
      get: function() {
        return this.rcApplication.percentageRevenueConstructionOther || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueConstructionOther = val;
      }
    },
    payrollConstructionOther: {
      get: function() {
        return this.rcApplication.payrollConstructionOther || '';
      },
      set: function(val) {
        this.rcApplication.payrollConstructionOther = val;
      }
    },
    revenueAnalyticalLaboratories: {
      get: function() {
        return this.rcApplication.revenueAnalyticalLaboratories || '';
      },
      set: function(val) {
        this.rcApplication.revenueAnalyticalLaboratories = val;
      }
    },
    percentageRevenueAnalyticalLaboratories: {
      get: function() {
        return this.rcApplication.percentageRevenueAnalyticalLaboratories || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueAnalyticalLaboratories = val;
      }
    },
    payrollAnalyticalLaboratories: {
      get: function() {
        return this.rcApplication.payrollAnalyticalLaboratories || '';
      },
      set: function(val) {
        this.rcApplication.payrollAnalyticalLaboratories = val;
      }
    },
    revenueAsbestos: {
      get: function() {
        return this.rcApplication.revenueAsbestos || '';
      },
      set: function(val) {
        this.rcApplication.revenueAsbestos = val;
      }
    },
    percentageRevenueAsbestos: {
      get: function() {
        return this.rcApplication.percentageRevenueAsbestos || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueAsbestos = val;
      }
    },
    payrollAsbestos: {
      get: function() {
        return this.rcApplication.payrollAsbestos || '';
      },
      set: function(val) {
        this.rcApplication.payrollAsbestos = val;
      }
    },
    revenueConstructionManagement: {
      get: function() {
        return this.rcApplication.revenueConstructionManagement || '';
      },
      set: function(val) {
        this.rcApplication.revenueConstructionManagement = val;
      }
    },
    percentageRevenueConstructionManagement: {
      get: function() {
        return this.rcApplication.percentageRevenueConstructionManagement || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueConstructionManagement = val;
      }
    },
    payrollConstructionManagement: {
      get: function() {
        return this.rcApplication.payrollConstructionManagement || '';
      },
      set: function(val) {
        this.rcApplication.payrollConstructionManagement = val;
      }
    },
    revenueEnvironmentalConsulting: {
      get: function() {
        return this.rcApplication.revenueEnvironmentalConsulting || '';
      },
      set: function(val) {
        this.rcApplication.revenueEnvironmentalConsulting = val;
      }
    },
    percentageRevenueEnvironmentalConsulting: {
      get: function() {
        return this.rcApplication.percentageRevenueEnvironmentalConsulting || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueEnvironmentalConsulting = val;
      }
    },
    payrollEnvironmentalConsulting: {
      get: function() {
        return this.rcApplication.payrollEnvironmentalConsulting || '';
      },
      set: function(val) {
        this.rcApplication.payrollEnvironmentalConsulting = val;
      }
    },
    revenueMoldFungusCommercial: {
      get: function() {
        return this.rcApplication.revenueMoldFungusCommercial || '';
      },
      set: function(val) {
        this.rcApplication.revenueMoldFungusCommercial = val;
      }
    },
    percentageRevenueMoldFungusCommercial: {
      get: function() {
        return this.rcApplication.percentageRevenueMoldFungusCommercial || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueMoldFungusCommercial = val;
      }
    },
    payrollMoldFungusCommercial: {
      get: function() {
        return this.rcApplication.payrollMoldFungusCommercial || '';
      },
      set: function(val) {
        this.rcApplication.payrollMoldFungusCommercial = val;
      }
    },
    revenueMoldFungusResidential: {
      get: function() {
        return this.rcApplication.revenueMoldFungusResidential || '';
      },
      set: function(val) {
        this.rcApplication.revenueMoldFungusResidential = val;
      }
    },
    percentageRevenueMoldFungusResidential: {
      get: function() {
        return this.rcApplication.percentageRevenueMoldFungusResidential || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueMoldFungusResidential = val;
      }
    },
    payrollMoldFungusResidential: {
      get: function() {
        return this.rcApplication.payrollMoldFungusResidential || '';
      },
      set: function(val) {
        this.rcApplication.payrollMoldFungusResidential = val;
      }
    },
    revenueProfessionalOther: {
      get: function() {
        return this.rcApplication.revenueProfessionalOther || '';
      },
      set: function(val) {
        this.rcApplication.revenueProfessionalOther = val;
      }
    },
    percentageRevenueProfessionalOther: {
      get: function() {
        return this.rcApplication.percentageRevenueProfessionalOther || '';
      },
      set: function(val) {
        this.rcApplication.percentageRevenueProfessionalOther = val;
      }
    },
    payrollProfessionalOther: {
      get: function() {
        return this.rcApplication.payrollProfessionalOther || '';
      },
      set: function(val) {
        this.rcApplication.payrollProfessionalOther = val;
      }
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    prev() {
      this.$router.push({
        name: "rc-application-1"
      });
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.rcApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
          this.state.pageTwoIsValid = false;
          this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {}
};
</script>

<style scoped>
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td:not(:first-child), table th:not(:first-child) {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
